// frontend/ThemeSwitcher.tsx
import React from 'react';
import { useSelector } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { themes } from './themes/theme';
import App from './App';
import { RootState } from './store/store';

const ThemeSwitcher: React.FC = () => {
  const themeMode = useSelector((state: RootState) => state.theme.mode);
  const theme = themes[themeMode];

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  );
};

export default ThemeSwitcher;